import { StringUtil } from '@ddt-web/generic-utils';
import * as get from 'lodash/get';

declare const Highcharts;

/**
 * PercentageTooltip: this tooltip includes the point value as a percentage.
 */
export class PercentageTooltip {
	public static getFormatter(): any {
		return function (): string {
			let tooltipHtml = '';
			let shouldSetTooltipHeader = true;
			get(this, 'points', []).forEach(point => {
				if (shouldSetTooltipHeader) {
					tooltipHtml += `<h4 class="performance-tooltip-header" style="">${Highcharts.dateFormat('%a, %b %e, %Y', this.x)}</h4>`;
					shouldSetTooltipHeader = false;
				}

				const seriesColor = point.series.color;
				tooltipHtml += `
					<div class="performance-tooltip">
						<table>
							<tr>
								<td>
									<div class="portfolio-icon" 
										style="background-color:${seriesColor};
										border-radius:50%; width:10px; 
										height:10px; display:inline-block; 
										margin-right:2px;">
									</div>
									${StringUtil.splitSpaceLessStringForChart(point.point.series.name, 50, true)}
								</td>
							</tr>
							<tr>
								<td></td>
								<td class="percent-value">
									${(point.y * 100).toFixed(2)}%
								</td>
							</tr>
						</table>
					</div>
				`;
			});
			return tooltipHtml;
		};
	}
}
